var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMascotSmall3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "4 4 44 44",
    fill: "#E48A99",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_74_24554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 48C38.1503 48 48 38.1503 48 26C48 13.8497 38.1503 4 26 4C13.8497 4 4 13.8497 4 26C4 38.1503 13.8497 48 26 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 48C38.1503 48 48 38.1503 48 26C48 13.8497 38.1503 4 26 4C13.8497 4 4 13.8497 4 26C4 38.1503 13.8497 48 26 48Z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3584 35.9577C36.5955 36.1153 36.7671 36.351 36.8421 36.6221C36.917 36.8932 36.8903 37.1817 36.7668 37.4352C36.6432 37.6886 36.4311 37.8902 36.1689 38.0032C35.9067 38.1163 35.6118 38.1334 35.3379 38.0513L28.1908 36.0491C28.0018 36.0394 27.8204 35.9732 27.671 35.8593C27.5216 35.7455 27.4114 35.5895 27.3552 35.4124C27.3637 35.2794 27.3999 35.1495 27.4614 35.0307C27.523 34.9119 27.6086 34.8067 27.7131 34.7215C27.8176 34.6363 27.9387 34.5729 28.069 34.5352C28.1993 34.4975 28.3361 34.4863 28.471 34.5023V31.8081C26.9731 32.1302 25.4226 32.1372 23.9217 31.8284V37.5053L27.6339 39.2349C27.8713 39.3924 28.0432 39.6282 28.1182 39.8995C28.1932 40.1708 28.1665 40.4595 28.0428 40.713C27.9191 40.9666 27.7067 41.1682 27.4443 41.2811C27.1818 41.3941 26.8867 41.4109 26.6127 41.3285L19.4663 39.3255C19.2773 39.3157 19.0959 39.2493 18.9465 39.1353C18.7972 39.0214 18.687 38.8653 18.6307 38.6881C18.5738 38.295 19.0293 37.7642 19.7459 37.778V33.4993C19.7459 31.9169 19.7459 30.4027 19.7459 29.9778C17.938 28.6609 16.5983 26.8199 15.9163 24.7151C15.2342 22.6104 15.2444 20.3486 15.9455 18.2499C16.6465 16.1512 18.0029 14.3219 19.8225 13.0208C21.6422 11.7197 23.833 11.0128 26.0849 11.0002C28.3369 10.9875 30.5358 11.6697 32.3705 12.9502C34.2053 14.2308 35.5829 16.0447 36.3084 18.1354C37.034 20.2261 37.0706 22.4876 36.4132 24.5999C35.7559 26.7121 34.4377 28.5682 32.6454 29.9052V34.2252L36.3584 35.9577ZM33.9846 20.221L33.9277 19.2231L27.9379 13.3295L27.0209 13.2874L26.0655 13.8871L23.8951 21.9172L24.3336 22.7309L25.2949 23.2095L33.4714 21.0375L33.9846 20.221Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3756 20.9394C29.8108 20.9394 30.9742 19.7985 30.9742 18.3911C30.9742 16.9837 29.8108 15.8428 28.3756 15.8428C26.9405 15.8428 25.7771 16.9837 25.7771 18.3911C25.7771 19.7985 26.9405 20.9394 28.3756 20.9394Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_74_24554",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.362353 0 0 0 0 0.418353 0 0 0 0 0.54902 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_74_24554"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_74_24554",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotSmall3);
export default __webpack_public_path__ + "static/media/mascot_small_3.12b2389fa36a3b20051791a2c9737082.svg";
export { ForwardRef as ReactComponent };